import { useMemo } from 'react'
import FontSelection from './FontSelection'
import FooterSelection from './FooterSelection'
import NavSelection from './NavSelection'
import { useEditorActions, useEditorData } from '../utils/hooks'
import { leftBarConfig } from '../cnst/editor.cnst'
import RightBarGroup from './RightBarGroup'
import Input from './Input'
import { useTr } from '../utils/useTr'

const SettingsTab = () => {
  const { patchConfig } = useEditorActions()
  const { workingConfig } = useEditorData()
  const { tr } = useTr()
  const editorLeftConfig = useMemo(
    () =>
      leftBarConfig({
        patchConfig,
        websiteConfig: workingConfig,
        tr,
      }),
    [patchConfig, workingConfig, tr]
  )
  return (
    <>
      {editorLeftConfig.map((group) => (
        <RightBarGroup title={group.title} key={group.key}>
          {group.fields.map((field) => (
            <Input {...field} key={`${group.key}-${field.key}`} />
          ))}
        </RightBarGroup>
      ))}
      <NavSelection />
      <FontSelection />
      <FooterSelection />
    </>
  )
}

export default SettingsTab
